<template>
    <div class="page">
        <div class="page-content">
            <div class="detail-page">
                <div class="d-cd-img">
                    <img src="../assets/images/qweqw.png" />
                    <ul class="cd-trgs">
                        <li>银联</li>
                    </ul>
                </div>
                <ul class="d-cd-desc">
                    <li><p class="p1">白金卡</p><p class="p2">卡片级别</p></li>
                    <li><p class="p1">56天</p><p class="p2">最长免息期</p></li>
                    <li><p class="p1">银联</p><p class="p2">发卡组织</p></li>
                    <li class="jj"><p class="p1">110.00元</p><p class="p2">奖金</p></li>
                </ul>
                <ul class="d-cd-desc">
                    <li><p class="p1">年费：1000元/年</p><p class="p2">固定年费</p></li>
                    <li><p class="p1">积分：1元=1积分 </p><p class="p2">3年有效期</p></li>
                </ul>
                <div class="d-cd-text">
                    <p class="pt">优惠权益</p>
                    <p class="pc">每周五12306渠道购票立减10%，<br>每月合计最高立减200元
                    五倍奖励积分，<br>每位持卡人每月奖励积分上限为5万积分
                    享受为期1年的本人不限次数铁路商务休息厅服务</p>
                </div>
            </div>
        </div>
        <toolBar type="detail"></toolBar>
    </div>
</template>
<script>
import toolBar from '../components/toolBar.vue'
export default {
    components: {
        toolBar
    }
}
</script>
